var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13558 10.4754H9.13558V8.80877H10.8022V6.80877H9.13558V5.1421H7.13558V6.80877H5.46891V8.80877H7.13558V10.4754ZM8.13558 14.9483C6.55191 14.5519 5.24453 13.6488 4.21341 12.2389C3.1823 10.829 2.66675 9.26344 2.66675 7.5421V3.38194L8.13558 1.33594L13.6044 3.38194V7.5421C13.6044 9.26344 13.0889 10.829 12.0577 12.2389C11.0266 13.6488 9.71925 14.5519 8.13558 14.9483ZM8.13558 13.3649C9.27258 12.9823 10.2155 12.2489 10.9644 11.1649C11.7133 10.0808 12.0877 8.87383 12.0877 7.54394V4.42794L8.13558 2.94794L4.18341 4.42994V7.5421C4.18341 8.87322 4.55786 10.0808 5.30675 11.1649C6.05564 12.2489 6.99858 12.9823 8.13558 13.3649Z",
    fill: "#2C2D2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/SecurityIcon.4430d47059b5b4ec1b321c339d2390f7.svg";
export { ForwardRef as ReactComponent };